import { render, staticRenderFns } from "./public-file.vue?vue&type=template&id=53859cd0"
import script from "./public-file.vue?vue&type=script&lang=js"
export * from "./public-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports